import moment from 'moment';
import { api } from 'common';
import { Column } from "material-table";
import { useState, useEffect } from 'react';
import cities from '../../lists/cities.json';
import { IUserType } from 'common/src/types';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { Assessment } from '@mui/icons-material';
import { useSelector, useDispatch } from "react-redux";
import { Autocomplete, TextField, Typography } from '@mui/material';
import { CustomMaterialTable } from 'components/CustomMaterialTable';
import { mainSignUpFleetAdmin } from 'common/src/actions/authactions';

export default function Users() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState<IUserType[]>([]);
    const usersdata = useSelector(state => state.usersdata);
    const settings = useSelector(state => state.settingsdata.settings);
    const {
        editUser,
        deleteUser,
        checkUserExists,
        fetchUsersOnce
    } = api;

    if (!settings) return;

    useEffect(() => {
        if (usersdata.staticusers) {
            setData(usersdata.staticusers.filter(user => user.usertype === 'fleetadmin'));
        }
    }, [usersdata.staticusers]);


    useEffect(() => {
        dispatch(fetchUsersOnce());
    }, [dispatch, fetchUsersOnce]);


    const columns: Column<IUserType>[] = [
        {
            editable: 'never',
            defaultSort: 'desc',
            field: 'createdAt',
            title: t('createdAt'),
            render: rowData =>
                <div style={{ width: 'max-content' }}>
                    {rowData.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY HH:mm') : null}
                </div>,
        },
        {
            title: t("name"),
            field: 'firstName',
            initialEditValue: ''
        },
        {
            field: 'city',
            title: t("cityLabel"),
            render: (rowData) =>
                <div style={{ width: 'max-content' }}>
                    {Array.isArray(rowData.city) ? rowData.city?.map(city => city.name).join(', ') : rowData.city}
                </div>,
            editComponent: (props) => (
                <Autocomplete
                    multiple
                    id="citys"
                    options={cities}
                    getOptionLabel={(option) => option.name}
                    style={{ width: 300 }}
                    renderInput={(params) => (
                        <TextField {...params} label={t("cityLabel")} variant="outlined" />
                    )}
                    onChange={(_, newValue) => {
                        props.onChange(newValue);
                    }}
                    value={props.value || []}
                />
            ),
        },
        {
            field: 'email',
            editable: 'onAdd',
            title: t('email'),
            render: rowData => settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
        },
        {
            title: t('password'),
            initialEditValue: '',
            field: 'password',
            editable: 'onAdd',
        },
    ];

    return (
        <CustomMaterialTable
            data={data}
            columns={columns}
            title={'fleetadmins'}
            isLoading={usersdata.loading}
            editable={{
                onRowAdd: newData =>
                    new Promise((resolve, reject) => {
                        if (!newData.city) {
                            alert(t('SELECT_A_CITY'));
                            reject();
                            return;
                        }
                        if (!newData.password) {
                            alert(t('password_blank_messege'));
                            reject();
                            return;
                        }
                        else {
                            checkUserExists(newData).then((res) => {
                                if (res.users && res.users.length > 0) {
                                    alert(t('user_exists'));
                                    reject();
                                }
                                else if (!(newData && newData.firstName)) {
                                    alert(t('proper_input_name'));
                                    reject();
                                }
                                else if (res.error) {
                                    alert(t('email_or_mobile_issue'));
                                    reject();
                                }
                                else {
                                    newData['usertype'] = 'fleetadmin';
                                    newData['createdAt'] = new Date().getTime();
                                    mainSignUpFleetAdmin(newData).then((res) => {
                                        setData(prevData => [...prevData, { ...newData, password: '', id: res.newDate.id }]);
                                    })
                                    resolve("");
                                }
                            });
                        }
                    }),
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            if (!(newData && newData.firstName)) {
                                alert(t('proper_input_name'));
                                reject();
                            } else {
                                resolve("");
                                if (newData !== oldData) {
                                    if (oldData && oldData.id) {
                                        delete newData.tableData;
                                        dispatch(editUser(oldData.id, newData));
                                        dispatch(fetchUsersOnce());
                                    }
                                }
                            }
                        }, 600);
                    }),
                onRowDelete: oldData =>
                    settings.AllowCriticalEditsAdmin ?
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve("");
                                dispatch(deleteUser(oldData));
                                dispatch(fetchUsersOnce());
                            }, 600);
                        })
                        :
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve("");
                                alert(t('demo_mode'));
                            }, 600);
                        })
                ,
            }}
            actions={[
                () => ({
                    icon: () => (
                        <div style={{ display: "flex", padding: "10px", alignItems: "center" }}>
                            <Assessment />
                            <Typography variant="subtitle2">
                                {t("report")}
                            </Typography>
                        </div>
                    ),
                    onClick: (_, fleetAdmin) => {
                        if (Array.isArray(fleetAdmin)) return
                        navigate(`/allreports/${fleetAdmin.id}/${fleetAdmin.firstName}`);
                    },
                }),
            ]}
        />
    );
}